import { render } from "./Widget4.vue?vue&type=template&id=d3695fc0&ts=true"
import script from "./Widget4.vue?vue&type=script&lang=ts"
export * from "./Widget4.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__